import { render, staticRenderFns } from "./SettingTemporary.vue?vue&type=template&id=58a6fd23"
import script from "./SettingTemporary.vue?vue&type=script&lang=js"
export * from "./SettingTemporary.vue?vue&type=script&lang=js"
import style0 from "./SettingTemporary.vue?vue&type=style&index=0&id=58a6fd23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports